import { gql } from "@apollo/client";
import { EnforcementIntentDetail, enforcementIntentDetailFragment } from "../fragments";

export const UPDATE_ENFORCEMENT_INTENT_VEHICLE_MAKE = gql`
  mutation UpdateEnforcementIntentVehicleMake($id: uuid!, $make: String!, $model: String!) {
    enforcementIntent: update_enforcement_intent_by_pk(
      pk_columns: { id: $id }
      _set: { vehicle_make: $make, vehicle_model: $model, vehicle_make_confidence: 100 }
    ) {
      ...enforcementIntentDetailFragment
    }
  }
  ${enforcementIntentDetailFragment}
`;

export interface UpdateEnforcementIntentVehicleMakeData {
  enforcementIntent: EnforcementIntentDetail;
}

export interface UpdateEnforcementIntentVehicleMakeVars {
  id: string;
  make: string;
  model: string;
}
